import { atom, useResetRecoilState } from 'recoil';
import { DateFilterState, DefaultDateFilter, useDateFilter } from './dateFilter';
import { HasAdjustments, PaymentStatus } from 'enums';

export type Sort = {
    text: string,
    order: 'asc' | 'desc',
    compare: (a: any, b: any) => number
};

export const PaymentSortOptions: Sort[] = [
    {
        text: 'Sort By',
        order: 'asc',
        compare: () => 0
    },
    {
        text: 'Paid Date: Ascending',
        order: 'asc',
        compare: (a: any, b: any) => a.paymentDate - b.paymentDate
    },
    {
        text: 'Paid Date: Descending',
        order: 'desc',
        compare: (a: any, b: any) => b.paymentDate - a.paymentDate
    },
    {
        text: 'Paid Amt: High to Low',
        order: 'desc',
        compare: (a: any, b: any) => b.paymentAmount - a.paymentAmount
    },
    {
        text: 'Paid Amt: Low to High',
        order: 'asc',
        compare: (a: any, b: any) => a.paymentAmount - b.paymentAmount
    },
    {
        text: 'Adjustment Amt: High to Low',
        order: 'desc',
        compare: (a: any, b: any) => b.adjustmentTotalAmount - a.adjustmentTotalAmount
    },
    {
        text: 'Adjustment Amt: Low to High',
        order: 'asc',
        compare: (a: any, b: any) => a.adjustmentTotalAmount - b.adjustmentTotalAmount
    }
];

type PaymentFilterState = {
    paymentStartAmount?: number,
    paymentEndAmount?: number,
    paymentStatus?: PaymentStatus,
    checkNumber?: string,
    voucherId?: string,
    hasAdjustments?: HasAdjustments,
    adjustmentStartAmount?: number,
    adjustmentEndAmount?: number,
    searchTerm?: string,
    searchKeys: string[],
    sort: Sort
} & DateFilterState;

export const paymentFilter = atom<PaymentFilterState>({
    key: 'paymentFilter',
    default: {
        ...DefaultDateFilter,
        searchKeys: ['paymentIdRef' , 'adjustmentTotalAmount', 'userVoucherDecimal', 'paymentAmount'],
        sort: PaymentSortOptions[2]
    }
});

export const usePaymentFilter = () => {
    const { setField, ...state } = useDateFilter(paymentFilter);

    return {
        ...state,
        setPaymentStartAmount: (value?: number) => setField('paymentStartAmount', value),
        setPaymentEndAmount: (value?: number) => setField('paymentEndAmount', value),
        setPaymentStatus: (value?: PaymentStatus) => setField('paymentStatus', value), 
        setCheckNumber: (value?: string) => setField('checkNumber', value),
        setVoucherId: (value?: string) => setField('voucherId', value),
        setHasAdjustments: (value?: HasAdjustments) => setField('hasAdjustments', value),
        setAdjustmentStartAmount: (value?: number) => setField('adjustmentStartAmount', value),
        setAdjustmentEndAmount: (value?: number) => setField('adjustmentEndAmount', value),
        setSearchTerm: (value?: string) => setField('searchTerm', value),
        setSort: (value: Sort) => setField('sort', value)
    };
};

export const useResetPaymentFilter = () => useResetRecoilState(paymentFilter);
